var _g, _g2, _g3, _g4;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgProjectAlertBell(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23.54,
    height: 23.49,
    viewBox: "-0.75 -0.75 23.54 23.49",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-0.75 1.12)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15.7195 10.281V13.3451H3.08203V7.06834C3.08203 3.57879 5.91101 0.75 9.40074 0.75C10.2329 0.75 11.0276 0.91083 11.7552 1.20317L11.9542 1.30584",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#A74E4E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.75 15.2537C0.75 16.308 1.60473 17.1627 2.65912 17.1627H16.1426C17.197 17.1627 18.0517 16.308 18.0517 15.2537C18.0517 14.1994 17.197 13.3447 16.1426 13.3447H2.65912C1.60473 13.3447 0.75 14.1994 0.75 15.2537Z",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#A74E4E"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(5.63 -0.75)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3.08014 0.75V2.26702",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#A74E4E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.08022 22.7427H3.08008C1.79321 22.7427 0.75 21.6995 0.75 20.4126V19.0408H5.4103V20.4126C5.4103 21.6995 4.36709 22.7427 3.08022 22.7427Z",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#A74E4E"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(9.87 -0.75)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.898 8.20184C12.0738 7.6526 12.1691 7.06736 12.1691 6.4598C12.1691 3.30636 9.61281 0.75 6.45952 0.75C3.30622 0.75 0.75 3.30636 0.75 6.4598C0.75 9.61323 3.30627 12.1696 6.45956 12.1696C7.28623 12.1696 8.07173 11.9937 8.78107 11.6775C9.9283 11.1663 11.2838 10.1209 11.898 8.20184Z",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#A74E4E"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(15.61 2.86)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0.75 0.75V2.89477L2.10559 3.81934",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#A74E4E"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgProjectAlertBell);
export default __webpack_public_path__ + "static/media/project-alert-bell.7075a1ffec5702541fe08f3076a0f043.svg";
export { ForwardRef as ReactComponent };